import { UserValueEnum } from "../enums/userValueEnum";
import { IBase } from "../interfaces/IBase";
import { USER } from "../types/indexTypeEnum";

export const USER_CONSTANTS: IBase[] = [
  {
    id: USER.SUPPORT_CREDIT,
    label: UserValueEnum.SUPPORT_CREDIT
  },
  {
    id: USER.AGENT_SIMPLE,
    label: UserValueEnum.AGENT_SIMPLE
  },
  {
    id: USER.CLIENT_SIMPLE,
    label: UserValueEnum.CLIENT_SIMPLE
  },
];
